// const MAIN_PRODUCT_ID = '9796522901831'; // OneStock product ID
// Item IDs in this list will allow lower priced add-ons to remain in cart. If item in the MAIN_PRODUCT_IDS is not in the cart, ACCESSORY_IDS will be auto removed from basket
const MAIN_PRODUCT_IDS = ['9796522901831', '10219248943431', '10215819968839', '10219262476615', '10230766764359', '10389207941447', '10175621988679', '10474165633351', '10474175430983', '10474174873927'];  // WVR25 - New Products IDs
// Product ids are the number string at the end of the product's URL in admin mode. October 15th added OneStock Pro, Ultimate and OneStock S to list
// November 17 2025 Added OneStock/pro/ultimate holiday bundles to the list

const ACCESSORY_IDS = [
  '9796525228359',  // Additional Controller Mounts
  '10054435635527', // Quick Release Bipod
  '10176356122951', // Grip Height Module
  '10175489245511', // Dual Sling Pack
  '9796524933447',   // Premium Neck Sling
  '10487026942279', // Basic Sling
  '10520436506951', // Basic Sling - Upsell Standard
  '10499114369351' //Magnetic Mount
];

const originalFetch = window.fetch;

window.fetch = async function (...args) {
  const response = await originalFetch.apply(this, args);

  if (args[0].includes('/cart.js')) {
    const data = await response.clone().json();
    const cartProducts = document.querySelectorAll('.cart-drawer__product');

    const checkedProducts = document.querySelectorAll('.upsell-product.checked');
    checkedProducts.forEach(item => {
      const label = item.querySelector('.upsell-product--checkbox label');
      label && label.click();
    });

    cartProducts.forEach(item => {
      if (item.getAttribute('data-property') != '') {
        const attr_key = item.getAttribute('data-property');
        const attrProducts = document.querySelectorAll(`.cart-drawer__product[data-property="${attr_key}"]`);
        if (attrProducts.length < 2 && attrProducts.length > 0) {
          const removeButton = attrProducts[0].querySelector('.js-cart-drawer-delete-btn');
          removeButton && removeButton.click();
        }
      }
    });

    const newCartPrice = document.querySelector('[data-mini-cart-price]');
    const checkoutSpan = document.querySelector('.checkout-now-price');
    const quantityInput = document.querySelector(".product-form__buttons sht-qty-inp .js-main-product-quantity-input");

    setTimeout(() => {
      const cartProducts = document.querySelectorAll('.cart-drawer__product');
      // const hasMain = Array.from(cartProducts).some(el => el.dataset.productId === MAIN_PRODUCT_ID);
      const hasMain = Array.from(cartProducts).some(el => MAIN_PRODUCT_IDS.includes(el.dataset.productId));
      if (!hasMain) {
        cartProducts.forEach(el => {
          if (ACCESSORY_IDS.includes(el.dataset.productId)) {
            const btn = el.querySelector('.js-cart-drawer-delete-btn');
            btn && btn.click();
          }
        });
      }
    }, 50);

    if (newCartPrice) {
      const price = newCartPrice.getAttribute('data-mini-cart-price');
      if (checkoutSpan) {
        checkoutSpan.dataset.price = +price;
        checkoutSpan.dataset.productPrice = +price + +window.prodPrice;
        checkoutSpan.innerHTML = ` - ${window.formatPriceHandler(+price + (+window.prodPrice * quantityInput.value))}`;
      }
    } else {
      if (checkoutSpan) {
        checkoutSpan.dataset.price = 0;
        checkoutSpan.dataset.productPrice = 0 + +window.prodPrice;
        checkoutSpan.innerHTML = ` - ${window.formatPriceHandler(+0 + (+window.prodPrice * quantityInput.value))}`;
      }
    }
  }

  return response;
};
